import MainDashboardAppConfig from './main/MainDashboardAppConfig';

const dashboardConfig = [MainDashboardAppConfig];

export default dashboardConfig;
